function createObject(fields, defaults) {

    let obj = Object.assign({}, defaults || {});

    (fields || []).forEach((field) => {
        if (obj.hasOwnProperty(field.name))
            return;
        obj[field.name] = null;
    });

    return obj;

};

function getObjectData(o) {

    if (!o)
        return {};

    return Object.getOwnPropertyNames(o).reduce(function (result, propName) {
        if (propName.slice(0, 1) != '$')
            result[propName] = o[propName];
        return result;
    }, {});

};

function changeObjectProp(o, name, value, validator) {

    if (!o)
        return;
    if (!o.hasOwnProperty(name))
        return;
    o[name] = value;
    if (validator)
        o.$valid = validator(o);
    return o;

};

function validateObject(o, validator) {

    if (!o)
        return;
    if (validator)
        o.$valid = validator(o);
    return o;

};

export {
    createObject,
    getObjectData,
    changeObjectProp,
    validateObject,
};
